import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import "./styles/AdminTags.css"; // ✅ Import styles
import { useStore } from "../../context/StoreContext"; // ✅ Import StoreContext

const AdminTags = () => {
  const { fetchProducts } = useStore(); // ✅ Get fetchProducts function
  
  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [csrfToken, setCsrfToken] = useState("");

  // ✅ Fetch CSRF Token
  useEffect(() => {
    const token = document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];

    if (token) setCsrfToken(token);
  }, []);

  // ✅ Fetch Tags
  const fetchTags = async () => {
    try {
      const response = await axios.get("/api/products/tags", { withCredentials: true });
      setTags(response.data.data);
    } catch (error) {
      console.error("🔥 Error fetching tags:", error.message);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  // ✅ Handle New Tag Submission
  const handleAddTag = async (e) => {
    e.preventDefault();

    if (!csrfToken) {
      console.error("🚨 CSRF token is missing. Request blocked.");
      return;
    }

    try {
      await axios.post("/api/admin/tags",
        { name: newTag },
        {
          withCredentials: true,
          headers: { "x-csrf-token": csrfToken }
        }
      );
      setNewTag("");
      fetchTags();
    } catch (error) {
      console.error("🔥 Error adding tag:", error.message);
    }
  };

  // ✅ Handle Tag Deletion
  const handleDeleteTag = async (tagId) => {
    if (!window.confirm("Are you sure you want to delete this tag?")) return;

    if (!csrfToken) {
      console.error("🚨 CSRF token is missing. Request blocked.");
      return;
    }

    try {
      await axios.delete(`/api/admin/tags/${tagId}`, {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken }
      });

      fetchTags();
      fetchProducts();
    } catch (error) {
      console.error("🔥 Error deleting tag:", error.message);
    }
  };

  return (
    <div>
      <h2>Manage Tags/Attributes</h2>
      <p className="admin-note">Note: Deleting a tag will remove it from all associated products. It will not delete the products.</p>

      {/* ✅ Add New Tag */}
      <form onSubmit={handleAddTag} className="add-tag-form">
        <input 
          type="text" 
          placeholder="New Tag Name" 
          value={newTag} 
          onChange={(e) => setNewTag(e.target.value)} 
          required 
        />
        <button type="submit">Add Tag</button>
      </form>

      {/* ✅ List of Tags */}
      <div className="tags-list">
        {tags.length > 0 ? (
          tags.map((tag) => (
            <div key={tag.id} className="tag-item">
              <span>{tag.name}</span>

              <button onClick={() => handleDeleteTag(tag.id)}>❌ Delete</button>
            </div>
          ))
        ) : (
          <p>No tags found.</p>
        )}
      </div>
    </div>
  );
};

export default AdminTags;